import { useState, useEffect } from "react";
import { ResponseGladly, SearchResult } from "typedef/ResponseGladly";

const useFaqs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [response, setResponse] = useState<ResponseGladly>();
  const [searchResult, setSearchResult] = useState<SearchResult[]>();

  const handleChangeSearch = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setSearchTerm(event.target.value.trim());
  };

  useEffect(() => {
    const baseUrl =
      "https://nftydoor.us-1.gladly.com/api/v1/orgs/PmjDDOOhSXmRiBCSM7zEbQ/answers/search?lng=en-us";
    if (searchTerm.length > 2) {
      (async () => {
        const answerList = (await fetch(`${baseUrl}&q=${searchTerm}`)).json();
        setSearchResult(await answerList);
      })();
    } else if (searchTerm.length === 0) {
      (async () => {
        const result = await fetch(
          "https://cdn.gladly.com/orgs/configs/help-center/nftydoor.com-en-us.json",
          {
            method: "GET",
            headers: {
              Authorization:
                "Basic Y29uc3VsdGFudC1qdXN0b0BuZnR5ZG9vci5jb206Yk1wUXdkQjFOM0Z4YTZKZ0xaV2JxS1lVTGdtZllFR2M=",
            },
            redirect: "follow",
          }
        );
        setResponse(await result.json());
      })();
    }
  }, [searchTerm]);

  useEffect(() => {
    (async () => {
      const result = await fetch(
        "https://cdn.gladly.com/orgs/configs/help-center/nftydoor.com-en-us.json",
        {
          method: "GET",
          headers: {
            Authorization:
              "Basic Y29uc3VsdGFudC1qdXN0b0BuZnR5ZG9vci5jb206Yk1wUXdkQjFOM0Z4YTZKZ0xaV2JxS1lVTGdtZllFR2M=",
          },
          redirect: "follow",
        }
      );
      setResponse(await result.json());
    })();
  }, []);

  return {
    response,
    searchTerm,
    searchResult,
    handleChangeSearch,
  };
};

export default useFaqs;
